import React from 'react';
import moment from 'moment';

const ChatListItem = ({ item }) => {
  return (
    <div className="d-flex flex-row border-bottom conversation">
      <div className="pl-3 pt-2 pr-2 pb-2 conversation">
        <p className="conversationdate">
          {moment(item.startedUtc).format('DD/MM/YYYY h:mm a')} (
          {item.visitorMessageCount}){' '}
        </p>
        {/* <p className="conversationdate">{(item.title)}  </p>    */}
        <div className="pr-4">
          <p className="mb-1 text-small">{item.detail}</p>
        </div>
        {/* <div class="text-medium font-weight-medium d-none d-sm-block">{item.chattime}</div>                */}
      </div>
    </div>
  );
};

export default React.memo(ChatListItem);
